import React from 'react';

const ProductDetailsHeader = ({ title, color, description, originImage, toggleOriginModal }) => (
  <div className="product-details__header">
    <h1 className="product-details__name">
      {title}
    </h1>

    <span className="product-details__color">
      {color}
    </span>

    {description &&
      <p className="product-details__description" dangerouslySetInnerHTML={
        {__html: description}
      }/>}

    {originImage &&
      <a
        href="#"
        onClick={toggleOriginModal}
        className="learn-more-link"
      >
        Product origins
      </a>}
  </div>
);

export default ProductDetailsHeader;



// WEBPACK FOOTER //
// ./assets/scripts/components/Product/ProductDetailsHeader.js